var getAttributedEntry = function getAttributedEntry(string, name, value) {
  return string.replace(/^\s*<[a-z]+/i, "$& data-".concat(name, "=\"").concat(value, "\""));
};

var getPrefixedEntry = function getPrefixedEntry(value, id) {
  return getAttributedEntry(value, 'csl-entry-id', id);
};

export { getAttributedEntry, getPrefixedEntry };